import React from 'react';
import { Select } from 'antd';

export const aSearchElements = [
  {
    label: 'Codigo',
    name: 'code',
    type: 'input',
  },
  {
    label: 'Descripcion',
    name: 'description',
    type: 'input',
  },
  {
    label: 'Estatus',
    name: 'status',
    placeholder: 'Todos',
    type: 'select',
    values: () => (
      <>
        <Select.Option value={1}>Activo</Select.Option>
        <Select.Option value={0}>Inactivo</Select.Option>
      </>
    ),
  },
];

export const oInitState = {
  code: '',
  description: '',
  status: undefined,
};
